import type { IconComponent } from '@twistopayments/design-system/icons'
import * as InlineSvgIcons from '@twistopayments/design-system/icons/inline'

import type { IconsIconComponent } from '@twisto/api-cms'

export const Icon = ({ name, color, size }: IconsIconComponent) => {
  const RenderIcon =
    name && (InlineSvgIcons as Record<string, IconComponent>)[name]

  if (!RenderIcon) {
    return null
  }

  return <RenderIcon color={color} size={size} />
}
